module.exports = "//static.hsappstatic.net/connect-dot-com-ui-components/static-1.2818/images/ios-app-store-button-white.svg"